import memoizeOne from 'memoize-one';
import _isEqual from 'lodash.isequal';

function getContext({
  state: {
    comments,
    userAssignedColors,
    commentModalId,
    commentModalProps,
    modalTarget,
    filterByMetadataFlag,
    isReadOnly,
    canResolveComment,
    resourceOrganisationId,
    closeModalOrigin,
    resourceOwnerUserId,
    assetsMap,
    isInternalMode,
    commentOrigin,
    notCommentOrigin,
    currentActivePage,
    pagesList,
    organisationName,
    allowedVisibilityOptions,
    allowedWriteVisibilityOptions,
    fetchComments,
    selectedComment
  } = {},
  actions
}) {
  return {
    state: {
      comments,
      userAssignedColors,
      commentModalId,
      commentModalProps,
      modalTarget,
      filterByMetadataFlag,
      isReadOnly,
      canResolveComment,
      resourceOrganisationId,
      closeModalOrigin,
      resourceOwnerUserId,
      assetsMap,
      isInternalMode,
      commentOrigin,
      notCommentOrigin,
      currentActivePage,
      pagesList,
      organisationName,
      allowedVisibilityOptions,
      allowedWriteVisibilityOptions,
      fetchComments,
      selectedComment
    },
    actions
  };
}

function contextHasChanges([newArgs], [oldArgs]) {
  return _isEqual(getContext(newArgs), getContext(oldArgs));
}

export default memoizeOne(getContext, contextHasChanges);